(function () {
  if (window.CrowdProductCardsLoaded) return;
  window.CrowdProductCardsLoaded = true;

  const selectors = {
    card: '[data-crowd-card]',
    slide: '[data-crowd-slide]',
    segment: '[data-crowd-progress-segment]',
    prev: '[data-crowd-prev]',
    next: '[data-crowd-next]',
    quickAdd: '[data-crowd-quick-add]',
    panel: '[data-crowd-size-panel]',
    closePanel: '[data-crowd-close-size]',
    sizeOption: '[data-crowd-size-option]'
  };

  function setActiveSlide(card, index) {
    const slides = Array.from(card.querySelectorAll(selectors.slide));
    const segments = Array.from(card.querySelectorAll(selectors.segment));
    if (!slides.length) return;

    const nextIndex = (index + slides.length) % slides.length;
    card.dataset.crowdIndex = String(nextIndex);

    slides.forEach((slide, slideIndex) => {
      const isActive = slideIndex === nextIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    segments.forEach((segment, segmentIndex) => {
      segment.classList.toggle('is-active', segmentIndex === nextIndex);
    });
  }

  function changeSlide(card, direction) {
    const current = Number(card.dataset.crowdIndex || 0);
    setActiveSlide(card, current + direction);
  }

  function closeAllPanels(exceptCard) {
    document.querySelectorAll(selectors.card).forEach((card) => {
      if (card === exceptCard) return;
      const panel = card.querySelector(selectors.panel);
      if (panel) {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function openPanel(card) {
    const panel = card.querySelector(selectors.panel);
    if (!panel) return;
    closeAllPanels(card);
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
  }

function closePanel(card) {
  const panel = card.querySelector(selectors.panel);
  if (!panel) return;
  panel.classList.remove('is-open');
  panel.setAttribute('aria-hidden', 'true');
  if (typeof panel.__crowdResetTwoStep === 'function') panel.__crowdResetTwoStep();
}
  function getCartUrl() {
    return window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
  }

  function showAddedConfirmation(data) {
    let confirmation = document.querySelector('[data-crowd-added]');

    if (!confirmation) {
      confirmation = document.createElement('div');
      confirmation.className = 'crowd-added';
      confirmation.setAttribute('data-crowd-added', '');
      confirmation.innerHTML = `
        <button class="crowd-added__close" type="button" data-crowd-added-close aria-label="Close">×</button>
        <div class="crowd-added__check" aria-hidden="true">✓</div>
        <h3 class="crowd-added__heading">Added to Bag</h3>
        <div class="crowd-added__body">
          <img class="crowd-added__image" data-crowd-added-image alt="">
          <div>
            <p class="crowd-added__title" data-crowd-added-title></p>
            <p class="crowd-added__meta">Size: <span data-crowd-added-size></span></p>
            <p class="crowd-added__meta">Qty: <span data-crowd-added-qty></span></p>
          </div>
        </div>
        <a class="crowd-added__view-bag" href="${getCartUrl()}">View Bag</a>
      `;
      document.body.appendChild(confirmation);

      confirmation.querySelector('[data-crowd-added-close]').addEventListener('click', () => {
        confirmation.classList.remove('is-open');
      });
    }

    const image = confirmation.querySelector('[data-crowd-added-image]');
    image.src = data.image || '';
    image.alt = data.title || '';
    confirmation.querySelector('[data-crowd-added-title]').textContent = data.title || '';
    confirmation.querySelector('[data-crowd-added-size]').textContent = data.size || '';
    confirmation.querySelector('[data-crowd-added-qty]').textContent = '1';
    confirmation.classList.add('is-open');
  }

  function refreshCartDrawer() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  fetch(`${window.Shopify.routes.root}?section_id=cart-drawer`)
    .then(r => r.text())
    .then(html => {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const newInner = parsed.querySelector('.cart-drawer');
      const currentInner = cartDrawer.querySelector('.cart-drawer');
      if (newInner && currentInner) {
        currentInner.innerHTML = newInner.innerHTML;
      }
      cartDrawer.classList.remove('is-empty');
fetch('/cart.js')
  .then(r => r.json())
  .then(cart => {
    const bubble = document.querySelector('#cart-icon-bubble');
    if (bubble) {
      const count = bubble.querySelector('[aria-hidden]');
      const visCount = bubble.querySelector('.visually-hidden');
      if (count) count.textContent = cart.item_count;
      if (visCount) visCount.textContent = cart.item_count + ' items';
      bubble.classList.remove('hidden');
    }
  });
      if (typeof cartDrawer.open === 'function') cartDrawer.open();
    })
    .catch(() => {});
}

  function addVariantToCart(button) {
    const variantId = button.dataset.variantId;
    if (!variantId || button.disabled) return;

    button.classList.add('is-selected');
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    })
      .then((response) => {
        if (!response.ok) throw new Error('Unable to add item');
        return response.json();
      })
      .then(() => {
        const card = button.closest(selectors.card);
        closePanel(card);
refreshCartDrawer();
      })
      .catch(() => {
        window.location.href = `/cart/add?id=${variantId}&quantity=1`;
      })
      .finally(() => {
        button.disabled = false;
        button.classList.remove('is-selected');
      });
  }

  // Products without sizes (e.g. pocket squares) have a single default variant.
  // For those, the + button adds straight to the bag instead of opening the size panel.
  const productCache = {};

  function getProductUrl(card) {
    const link = card.querySelector('.crowd-card__title') || card.querySelector('.crowd-card__media-link');
    if (!link) return null;
    const url = new URL(link.getAttribute('href'), window.location.origin);
    return url.pathname.replace(/\/$/, '');
  }

  function fetchProduct(card) {
    const path = getProductUrl(card);
    if (!path) return Promise.reject(new Error('No product URL'));
    if (!productCache[path]) {
      productCache[path] = fetch(`${path}.js`, { headers: { Accept: 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error('Unable to load product');
          return response.json();
        })
        .catch((error) => {
          delete productCache[path];
          throw error;
        });
    }
    return productCache[path];
  }

  function isSingleVariant(product) {
    return product && product.variants && product.variants.length === 1;
  }

  function handleQuickAdd(card, quickAdd) {
    if (quickAdd.dataset.variantId) {
      addVariantToCart(quickAdd);
      return;
    }
    if (quickAdd.dataset.crowdHasSizes === 'true') {
      openPanel(card);
      return;
    }

    quickAdd.disabled = true;
    fetchProduct(card)
      .then((product) => {
        quickAdd.disabled = false;
        if (!isSingleVariant(product)) {
          quickAdd.dataset.crowdHasSizes = 'true';
          openPanel(card);
          return;
        }
        const variant = product.variants[0];
        if (!variant.available) {
          window.location.href = getProductUrl(card);
          return;
        }
        quickAdd.dataset.variantId = variant.id;
        addVariantToCart(quickAdd);
      })
      .catch(() => {
        quickAdd.disabled = false;
        openPanel(card);
      });
  }

  function bindTwoStepPanel(card, panel) {
  const dataScript = panel.querySelector('[data-crowd-variant-data]');
  const variants = dataScript ? JSON.parse(dataScript.textContent) : [];
  const topGroup = panel.querySelector('[data-crowd-top-group]');
  const bottomGroup = panel.querySelector('[data-crowd-bottom-group]');
  const label = panel.querySelector('[data-crowd-panel-label]');

  function resetTwoStep() {
    panel.dataset.topSize = '';
    topGroup.removeAttribute('hidden');
    topGroup.classList.remove('is-collapsed');
    bottomGroup.setAttribute('hidden', '');
    bottomGroup.classList.add('is-collapsed');
    topGroup.querySelectorAll('[data-crowd-top-size]').forEach((b) => b.classList.remove('is-selected'));
    bottomGroup.querySelectorAll('[data-crowd-bottom-size]').forEach((b) => {
      b.disabled = true;
      b.classList.remove('is-selected');
      const stock = b.querySelector('[class*="stock"]');
      if (stock) stock.textContent = '';
    });
    if (label) label.textContent = 'Select shirt size';
  }

  topGroup.querySelectorAll('[data-crowd-top-size]').forEach((button) => {
    button.addEventListener('click', () => {
      const topSize = button.dataset.size;
      panel.dataset.topSize = topSize;

      topGroup.querySelectorAll('[data-crowd-top-size]').forEach((b) => b.classList.toggle('is-selected', b === button));

      bottomGroup.querySelectorAll('[data-crowd-bottom-size]').forEach((bottomButton) => {
        const bottomSize = bottomButton.dataset.size;
        const match = variants.find((v) => v.top === topSize && v.bottom === bottomSize);
        const stock = bottomButton.querySelector('.crowd-size-panel__stock');

        if (match && match.available) {
          bottomButton.disabled = false;
          bottomButton.dataset.variantId = match.id;
          if (stock) stock.textContent = '';
        } else {
          bottomButton.disabled = true;
          delete bottomButton.dataset.variantId;
          if (stock) stock.textContent = 'Sold out';
        }
      });

      topGroup.setAttribute('hidden', '');
      topGroup.classList.add('is-collapsed');
      bottomGroup.removeAttribute('hidden');
      bottomGroup.classList.remove('is-collapsed');
      if (label) label.textContent = 'Select pant size';
    });
  });

  bottomGroup.querySelectorAll('[data-crowd-bottom-size]').forEach((button) => {
    button.addEventListener('click', () => {
      if (button.disabled || !button.dataset.variantId) return;
      button.dataset.productTitle = card.querySelector(selectors.quickAdd)?.getAttribute('aria-label') || '';
      button.dataset.productImage = card.querySelector('.crowd-card__image')?.src || '';
      addVariantToCart(button);
    });
  });

  panel.__crowdResetTwoStep = resetTwoStep;
}
  function bindCard(card) {
    if (card.dataset.crowdBound === 'true') return;
    card.dataset.crowdBound = 'true';
    card.dataset.crowdIndex = '0';

    const prev = card.querySelector(selectors.prev);
    const next = card.querySelector(selectors.next);
    const media = card.querySelector('[data-crowd-carousel]');
    const quickAdd = card.querySelector(selectors.quickAdd);
    const close = card.querySelector(selectors.closePanel);

    if (prev) {
      prev.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        changeSlide(card, -1);
      });
    }

    if (next) {
      next.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        changeSlide(card, 1);
      });
    }

    if (quickAdd) {
      if (card.querySelector(`${selectors.sizeOption}, [data-crowd-top-size]`)) {
        quickAdd.dataset.crowdHasSizes = 'true';
      }
      quickAdd.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        handleQuickAdd(card, quickAdd);
      });
    }

    if (close) {
      close.addEventListener('click', () => closePanel(card));
    }

    card.querySelectorAll(selectors.sizeOption).forEach((button) => {
      button.addEventListener('click', () => addVariantToCart(button));
    });

    const panel = card.querySelector(selectors.panel);
if (panel && panel.hasAttribute('data-two-step')) {
  bindTwoStepPanel(card, panel);
}

    if (media) {
      let startX = 0;
      let startY = 0;
      let isSwiping = false;

      media.addEventListener('touchstart', (event) => {
        if (!event.touches || event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        isSwiping = true;
      }, { passive: true });

      media.addEventListener('touchmove', (event) => {
        if (!isSwiping || !event.touches || event.touches.length !== 1) return;
        const deltaX = event.touches[0].clientX - startX;
        const deltaY = event.touches[0].clientY - startY;
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 12) {
          event.preventDefault();
        }
      }, { passive: false });

      media.addEventListener('touchend', (event) => {
        if (!isSwiping || !event.changedTouches || event.changedTouches.length !== 1) return;
        const deltaX = event.changedTouches[0].clientX - startX;
        const deltaY = event.changedTouches[0].clientY - startY;
        isSwiping = false;

        if (Math.abs(deltaX) > 45 && Math.abs(deltaX) > Math.abs(deltaY)) {
          changeSlide(card, deltaX < 0 ? 1 : -1);
        }
      }, { passive: true });
    }
  }

  function initCards() {
    document.querySelectorAll(selectors.card).forEach(bindCard);
  }

  document.addEventListener('click', (event) => {
    if (!event.target.closest(selectors.card)) closeAllPanels();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAllPanels();
  });

document.addEventListener('DOMContentLoaded', initCards);
document.addEventListener('shopify:section:load', initCards);
document.addEventListener('recommendations:loaded', initCards);
initCards();

const observer = new MutationObserver((mutations) => {
  const hasNewCards = mutations.some((mutation) => {
    return Array.from(mutation.addedNodes).some((node) => {
      if (!(node instanceof HTMLElement)) return false;
      return node.matches?.(selectors.card) || node.querySelector?.(selectors.card);
    });
  });

  if (hasNewCards) initCards();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

setTimeout(initCards, 500);
setTimeout(initCards, 1500);
})();
